/* Generated by scripts/apply-brand.js from src/data/products.json — do not edit by hand */
import type { Product } from "./productTypes";
import img0 from "../assets/course-cards/certlrs.jpg";
import img1 from "../assets/course-cards/duke-elder.jpg";
import img2 from "../assets/course-cards/frcophth-part-1.jpg";
import img3 from "../assets/course-cards/frcophth-part-2.jpg";
import img4 from "../assets/course-cards/ico-part-a.jpg";
import img5 from "../assets/course-cards/ico-part-b.jpg";
import img6 from "../assets/course-cards/ico-part-c.jpg";
import img7 from "../assets/course-cards/interview-pack-st1.jpg";
import img8 from "../assets/course-cards/msra.jpg";
import img9 from "../assets/products/interview-coaching.jpg";
import img10 from "../assets/products/portfolio-builder.jpg";

export const BRAND_PRODUCTS: readonly Product[] = [
  {
    "title": "FRCOphth Part 1",
    "id": "frcophth1",
    "price": 179,
    "comingSoon": false,
    "description": "6,000+ total questions (5,000+ exam-style MCQs & 900+ high-yield questions) covering every module and every syllabus area for Part 1—questions match the wording and format of real papers. Timed practice and mock exams, detailed explanations, and analytics.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/frcophth-part-1.jpg",
    "subjectNames": [
      "FRCOphth Part 1"
    ],
    "trialable": true
  },
  {
    "title": "FRCOphth Part 2 (Written)",
    "id": "frcophth2",
    "price": 199,
    "comingSoon": false,
    "description": "11,550+ total questions (10,000+ clinically focused MCQs & 1,550+ high-yield questions) covering every module and every area of the Part 2 syllabus—exam-style stems that mirror real questions. Timed mock exams, management scenarios, and advanced coverage built for exam day.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/frcophth-part-2.jpg",
    "subjectNames": [
      "FRCOphth Part 2 (Written)",
      "FRCOphth Part 2"
    ],
    "trialable": true
  },
  {
    "title": "CertLRS",
    "id": "certlrs",
    "price": 499,
    "comingSoon": false,
    "description": "3,897 questions—the first CertLRS question bank—built for the RCOphth Certificate in Laser and Refractive Surgery MCQ. Covers laser and lens-based refractive surgery, patient selection, complications, and professional practice.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/certlrs.jpg",
    "subjectNames": [
      "CertLRS"
    ],
    "trialable": true
  },
  {
    "title": "ICO Part A",
    "id": "ico_part_a",
    "price": 149,
    "comingSoon": false,
    "description": "4,000 Visual Sciences MCQs for ICO Part A—anatomy, physiology, pathology, pharmacology, genetics, and statistics, written for the 120-question basic-sciences paper.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/ico-part-a.jpg",
    "subjectNames": [
      "ICO Part A"
    ],
    "trialable": true
  },
  {
    "title": "ICO Part B",
    "id": "ico_part_b",
    "price": 99,
    "comingSoon": false,
    "description": "3,000 MCQs on optics, refraction, and ophthalmic instruments for ICO Part B—the shorter 60-question paper where lens formulae and clinical optics matter.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/ico-part-b.jpg",
    "subjectNames": [
      "ICO Part B"
    ],
    "trialable": true
  },
  {
    "title": "ICO Part C",
    "id": "ico_part_c",
    "price": 149,
    "comingSoon": false,
    "description": "4,000 clinical MCQs for ICO Part C—cornea, glaucoma, retina, neuro-ophthalmology, paediatrics, uveitis, and the subspecialty breadth the final Standard exam tests.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/ico-part-c.jpg",
    "subjectNames": [
      "ICO Part C"
    ],
    "trialable": true
  },
  {
    "title": "Duke Elder Resource",
    "id": "duke_elder",
    "price": 120,
    "comingSoon": false,
    "description": "Ophthalmology in 1000 MCQs - A comprehensive MCQ-based revision resource for the Duke Elder Ophthalmology Examination",
    "length": "Physical Book",
    "css": "linear-gradient-3",
    "purchasable": false,
    "externalPurchaseUrl": "https://www.amazon.co.uk/Ophthalmology-1000-MCQs-Diya-Baker/dp/3032145708",
    "cardImage": "course-cards/duke-elder.jpg",
    "subjectNames": [
      "Duke Elder Resource",
      "Duke Elder"
    ],
    "trialable": true
  },
  {
    "title": "Interview Coaching",
    "id": "interview_coaching",
    "price": 349,
    "comingSoon": false,
    "showOnSignUp": false,
    "checkoutUrl": "https://buy.stripe.com/dRmaEYdaG0HT0Wh5tk3Ru00?locale=en-GB&__embed_source=1",
    "description": "1-to-1 interview coaching delivered by leading UK ophthalmologists—structured, high-quality preparation from clinicians who know the ST1 interview process inside out.",
    "length": "full day (2 sessions - 10 hours total)",
    "css": "linear-gradient-2",
    "cardImage": "products/interview-coaching.jpg",
    "subjectNames": [
      "Interview Coaching"
    ],
    "trialable": true
  },
  {
    "title": "Portfolio Builder",
    "id": "portfolio_builder",
    "price": 349,
    "comingSoon": false,
    "showOnSignUp": false,
    "description": "1-to-1 expert portfolio review and question bank for trainee/junior doctors to build a portfolio to get to the Ophthalmology interview stage",
    "length": "full day (2 sessions)",
    "css": "linear-gradient-2",
    "cardImage": "products/portfolio-builder.jpg",
    "subjectNames": [
      "Portfolio Builder"
    ],
    "trialable": true
  },
  {
    "title": "Interview Pack (ST1)",
    "id": "interview_pack_st1",
    "price": 149,
    "comingSoon": false,
    "description": "Interview pack with 79 Ophthalmology scenarios with actor briefs, candidate briefs, a mark scheme, and key points, to help perfect your Ophthalmology interviews.",
    "length": "6 months",
    "css": "linear-gradient-2",
    "cardImage": "course-cards/interview-pack-st1.jpg",
    "subjectNames": [
      "Interview Pack (ST1)"
    ],
    "trialable": false
  },
  {
    "title": "MSRA",
    "id": "msra",
    "price": 50,
    "comingSoon": false,
    "description": "2,300+ clinical MCQs, 2,000+ EMQ part questions (600+ EMQ groups of 3), and 700+ SJTs (professional dilemmas)—medic-reviewed and aligned to real MSRA format and difficulty.",
    "length": "6 months",
    "css": "",
    "cardImage": "course-cards/msra.jpg",
    "subjectNames": [
      "MSRA"
    ],
    "trialable": true
  }
];

export const CARD_IMAGES: Record<string, string> = {
  "course-cards/certlrs.jpg": img0,
  "course-cards/duke-elder.jpg": img1,
  "course-cards/frcophth-part-1.jpg": img2,
  "course-cards/frcophth-part-2.jpg": img3,
  "course-cards/ico-part-a.jpg": img4,
  "course-cards/ico-part-b.jpg": img5,
  "course-cards/ico-part-c.jpg": img6,
  "course-cards/interview-pack-st1.jpg": img7,
  "course-cards/msra.jpg": img8,
  "products/interview-coaching.jpg": img9,
  "products/portfolio-builder.jpg": img10,
};
